import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  return (
    <div className="jumbotron">
      <h1 className="display-4">Welcome to Bookeeping SaaS</h1>
      <p className="lead">Manage your Profit & Loss and Balance Sheet with ease by uploading bank statement CSVs.</p>
      <hr className="my-4" />
      <p>Start by creating your accounts and then import your transactions.</p>
      <div className="d-flex">
        <Link className="btn btn-primary btn-lg mr-2" to="/accounts" role="button">Manage Accounts</Link>
        <Link className="btn btn-success btn-lg" to="/transactions" role="button">Import Transactions</Link>
      </div>
    </div>
  );
};

export default Dashboard;
